import React from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/styles';

const styles = theme => ({
  link: {
    textDecoration: 'none',
    transition: 'all 0.3s ease-in-out',
    textDecorationColor: `${theme.palette.text.white} !important`,
    color: theme.palette.text.lgrey,
    '&:hover': {
      textDecoration: 'underline',
      color: theme.palette.text.light,
    },
  },
});

function TextLink(props) {
  const { title, link, classes } = props;
  return (
    <Typography
      component={Link}
      to={link}
      className={classes.link}
      variant="subtitle1"
    >
      {title}
    </Typography>
  );
}

TextLink.propTypes = {
  title: PropTypes.string.isRequired,
  link: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(TextLink);
